import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { FiArrowRight, FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const quinceImg = '/assets/img/quince.png';

const SideBarMenu = ({ isOpen, toggleSidebar }) => {
  const { t, i18n } = useTranslation();
  const [isLangOpen, setIsLangOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangOpen(false);
  };

  const menuItems = [
    { name: t('menu.home'),     path: '/' },
    { name: t('menu.boutique'), path: '/boutique' },
    { name: t('menu.aboutus'),  path: '/aboutus' },
    { name: t('menu.contact'),  path: '/contact' },
    { name: t('menu.sales'),    path: '/sales' },
    { name: t('menu.events'),   path: '/events' },
  ];

  return (
    <div
      className="fixed inset-0 z-50"
      style={{
        opacity:     isOpen ? 1 : 0,
        visibility:  isOpen ? 'visible' : 'hidden',
        transition: `opacity 0.3s ease-in-out, visibility 0s ${isOpen ? '0s' : '0.3s'}`,
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(23,18,13,0.6)', backdropFilter: 'blur(4px)' }}
        onClick={toggleSidebar}
      />

      {/* Panneau gauche */}
      <div
        className="absolute left-0 top-0 bottom-0 w-full md:w-2/3 lg:w-2/5 flex flex-col"
        style={{
          backgroundColor: '#2E2318',
          transform:   isOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition:  'transform 0.35s cubic-bezier(0.4,0,0.2,1)',
          borderRight: '1px solid rgba(217,166,65,0.2)',
        }}
      >
        {/* Coings decoratifs */}
        <img src={quinceImg} alt="" aria-hidden="true"
          className="absolute bottom-24 right-6 w-32 pointer-events-none opacity-[0.05]"
          style={{ filter: 'brightness(0) invert(1)' }} />

        {/* Bouton fermer */}
        <button
          className="absolute top-6 right-6 rounded-full p-2 transition-all hover:bg-white/10"
          onClick={toggleSidebar}
          aria-label="Fermer"
        >
          <AiOutlineClose className="text-2xl text-white" />
        </button>

        {/* Liseré doré en haut */}
        <div className="h-px w-full" style={{ background: 'linear-gradient(90deg, transparent, rgba(217,166,65,0.5), transparent)' }} />

        <div className="flex-1 overflow-y-auto px-8 md:px-12 lg:px-16 pt-20 pb-10">
          {!isLangOpen ? (
            <>
              <span className="text-xs font-semibold tracking-[0.35em] uppercase" style={{ color: '#D9A641' }}>
                Navigation
              </span>

              <nav className="mt-8 space-y-1">
                {menuItems.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    onClick={toggleSidebar}
                    className={({ isActive }) =>
                      `block font-sans text-3xl md:text-4xl py-2 transition-all duration-200 ${
                        isActive ? 'opacity-100' : 'opacity-60 hover:opacity-100'
                      }`
                    }
                    style={{ color: '#F7F2E8' }}
                  >
                    {item.name}
                  </NavLink>
                ))}
              </nav>

              {/* Langue */}
              <button
                className="mt-10 w-full flex items-center justify-between font-nunito text-base py-4 border-t transition-all hover:opacity-70"
                style={{ color: 'rgba(247,242,232,0.6)', borderColor: 'rgba(217,166,65,0.2)' }}
                onClick={() => setIsLangOpen(true)}
              >
                <span>{t('menu.language')}</span>
                <FiArrowRight />
              </button>
            </>
          ) : (
            <>
              <button
                className="flex items-center gap-2 font-sans text-2xl mb-10 opacity-70 hover:opacity-100 transition-opacity"
                style={{ color: '#F7F2E8' }}
                onClick={() => setIsLangOpen(false)}
              >
                <FiArrowLeft />
                <span>{t('menu.language')}</span>
              </button>

              <div className="space-y-6">
                {[
                  { code: 'fr', label: 'Français' },
                  { code: 'en', label: 'English' },
                ].map(({ code, label }) => (
                  <label key={code} className="flex items-center gap-4 cursor-pointer group">
                    <span
                      className="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
                      style={{
                        borderColor: i18n.language === code ? '#D9A641' : 'rgba(247,242,232,0.4)',
                        backgroundColor: i18n.language === code ? '#D9A641' : 'transparent',
                      }}
                    >
                      {i18n.language === code && <span className="w-2 h-2 rounded-full bg-white" />}
                    </span>
                    <input type="radio" name="language" value={code} className="hidden" onChange={() => changeLanguage(code)} checked={i18n.language === code} />
                    <span className="font-nunito text-xl transition-opacity group-hover:opacity-100 opacity-70" style={{ color: '#F7F2E8' }}>
                      {label}
                    </span>
                  </label>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Footer sidebar */}
        <div className="px-8 md:px-12 lg:px-16 py-6 border-t" style={{ borderColor: 'rgba(217,166,65,0.15)' }}>
          <p className="font-nunito text-xs" style={{ color: 'rgba(247,242,232,0.35)' }}>
            L'abus d'alcool est dangereux pour la santé.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SideBarMenu;